export const ONE_ANSWER = 'oneAnswer';
export const MULTIPLE_ANSWERS = 'multipleAnswers';
export const NPS = 'nps';
export const OPEN_QUESTION = 'openQuestion';
export const RATING = 'rating';
export const LIKE_DISLIKE = 'likeDislike';
